import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { Eyebrow, Item, Reveal, Stagger } from "../components/Reveal";

const STATS = [
  { value: 500, prefix: "+", label: "demandas resolvidas" },
  { value: 300, prefix: "+", label: "imóveis atendidos" },
  { value: 50, prefix: "+", label: "profissionais parceiros" },
  { value: 24, suffix: "h", label: "para iniciar a análise" },
];

const Counter = ({ value, prefix = "", suffix = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 1.8,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, value]);

  return (
    <span ref={ref}>
      {prefix}
      {display.toLocaleString("pt-BR")}
      {suffix}
    </span>
  );
};

export const Stats = () => (
  <section
    className="bg-ice relative overflow-hidden border-y border-slate-200/70 py-20 lg:py-24"
    data-testid="stats-section"
  >
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="mb-12">
        <Eyebrow>A Resolv em números</Eyebrow>
      </Reveal>
      <Stagger className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
        {STATS.map((s) => (
          <Item key={s.label} data-testid={`stat-${s.label.replace(/\s+/g, "-")}`}>
            <div className="border-l-2 border-brand/30 pl-6">
              <p className="font-display text-5xl font-extrabold tracking-tight text-petrol lg:text-6xl">
                <Counter value={s.value} prefix={s.prefix} suffix={s.suffix} />
              </p>
              <p className="mt-2 text-sm font-medium text-slate-500">{s.label}</p>
            </div>
          </Item>
        ))}
      </Stagger>
    </div>
  </section>
);
